import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { GlobalContext } from 'providers/GlobalProvider';
import { ITeam } from 'interfaces/IUser';

interface ITeamOption {
  label: string,
  value: string,
  team: ITeam
}

export const TeamPicker: React.FC = () => {
  const { cur_user, handleTeamChange } = useContext(GlobalContext);
  const [ teamOptions, setTeamOptions ] = useState<ITeamOption[]>();
  const history = useHistory();

  const getTeamFromOption = (id: string): ITeam => {
    const foundTeam = teamOptions?.find((t: ITeamOption) => t.value === id);
    return foundTeam ? foundTeam.team : { id: 'EMPTY_TEAM', name: 'EMPTY_TEAM', path: 'EMPTY_TEAM' };
  };

  const formatTeamOptions = (teams: ITeam[]): ITeamOption[] => {
    return teams.map((t: ITeam) => ({
      label: t.name ? t.name : '',
      value: t.id,
      team: t
    }));
  };

  // const formatTeamPath = (path: string) => {
  //   const cleaned_path = path.replaceAll('/', ' ').trimStart();
  //   const split_path = cleaned_path.split(' ');
  //   return split_path.map((word) => {
  //     return word[0].toUpperCase() + word.substring(1);
  //   }).join(' ');
  // };


  useEffect(() => {
    const userTeams: ITeamOption[] = formatTeamOptions(cur_user.teams);
    setTeamOptions(userTeams);
  }, [ cur_user ]);

  return (
    <Select
      className='select-team-box'
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          neutral0: '#2E3036',
          primary25: '#4895EF',
          neutral80: 'white',
          primary75: 'red'
        },
      })}
      id='selectedTeam'
      options={teamOptions}
      backspaceRemovesValue={true}
      escapeClearsValue={true}
      value={teamOptions ? teamOptions.find((t: ITeamOption) => t.value === cur_user.selected_team?.id) : ''}
      onChange={(e: any) => {
        handleTeamChange(getTeamFromOption(e.value)).then(history.push('/'));
      }}
    />
  );
};

